module.exports = __webpack_public_path__ + "media/images/new/icons/arrow_next-ca8e529fd523ba03a077e92d7375cc8a.png";